import { render, staticRenderFns } from "./newsTable.vue?vue&type=template&id=6c962ed0&"
import script from "./newsTable.vue?vue&type=script&lang=js&"
export * from "./newsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports